import { useFlags, useMarketTrends, useMarketData, useWidgetContext } from '@widget/core';
import { GenericUspList } from './GenericUspList';
import { LocalizedUspListOld } from './LocalizedUspListOld';

import type { USPItemProps } from '../USPItem';

type DynamicUspListProps = {
  upsItems: USPItemProps[] | undefined | null;
  localizedUspLabel: string | undefined | null;
  forceMobileMode?: boolean;
};

export const DynamicUspListOld = ({
  upsItems,
  localizedUspLabel,
  forceMobileMode = false,
}: DynamicUspListProps): JSX.Element => {
  const { showLocalizedUSP, exludeLocalizedUspForMarkets } = useFlags();
  const { market } = useMarketData();
  const { marketTrends } = useMarketTrends();
  const { activeId, getStepProps } = useWidgetContext();
  const disableLocalizedUsp = getStepProps(activeId)?.disableLocalizedUsp;
  const uspLayout = getStepProps(activeId)?.uspLayout;

  if (disableLocalizedUsp) {
    return <GenericUspList upsItems={upsItems} />;
  }

  if (
    showLocalizedUSP &&
    !exludeLocalizedUspForMarkets?.includes(market) &&
    marketTrends !== undefined
  ) {
    return (
      <LocalizedUspListOld
        label={localizedUspLabel || ''}
        uspLayout={uspLayout}
        forceMobileMode={forceMobileMode}
      />
    );
  }
  return <GenericUspList upsItems={upsItems} />;
};
